import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=20cd931d&"
import script from "./Rate.vue?vue&type=script&lang=js&"
export * from "./Rate.vue?vue&type=script&lang=js&"
import style0 from "./Rate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports